import { RouteComponentProps, withRouter } from 'react-router-dom'

import { GenericAnalyticsClient, withAnalyticsClient } from '@acorns/web-utils'
import { compose, createSink, shouldUpdate } from 'recompose'

import defaults from 'components/trackers/defaults'
import { isEarlyAccess } from 'utils/early-access'

import isBlacklisted from './blacklist'
import events from './events'

const SCREEN_VIEWED = 'Screen Viewed'
const EARLY_ACCESS_VIEWED = 'earlyAccessViewed'

const enhance = compose(
  withAnalyticsClient,
  withRouter,
  shouldUpdate<RouteComponentProps<{}>>(
    (props, nextProps) => props.location !== nextProps.location,
  ),
)

export const baseTrackPageFields = (
  location: RouteComponentProps<{}>['location'] | undefined,
) => ({
  hash: location?.hash,
  path: location?.pathname,
  search: location?.search,
  title: document.title,
})

export const trackPage = ({
  analytics,
  location,
}: RouteComponentProps<{}> & { analytics: GenericAnalyticsClient }) => {
  const fields = events(location)

  if (!isBlacklisted(location.pathname)) {
    analytics.track(SCREEN_VIEWED, {
      ...defaults(SCREEN_VIEWED),
      ...baseTrackPageFields(location),
      ...fields,
    })
  }
  if (isEarlyAccess()) {
    analytics.track(EARLY_ACCESS_VIEWED, {
      tag: process.env.RELEASE_TAG,
    })
  }
}

export default enhance(createSink(trackPage as any))
